import { createRouter, createWebHistory } from 'vue-router'
import Home from './templates/Home.vue'
import Agency from './templates/Agency.vue'
import Contact from './templates/Contact.vue'
import CaseStudies from './templates/CaseStudies.vue'
import TeamMember from './template-parts/agency/SingleMember.vue'
import CaseStudy from './template-parts/case-studies/SingleStudy.vue'
import Page404 from './templates/404.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Home,
      meta: { showHeader: true, showFooter: true, showMedium: true },
    },
    {
      path: '/agency',
      component: Agency,
      meta: { showHeader: true, showFooter: true, showDarkHeader: true },
    },
    {
        path: '/contact',
        component: Contact,
        meta: { showHeader: true, showFooter: true },
    },
    {
        path: '/case-studies',
        component: CaseStudies,
        meta: { showHeader: true, showFooter: true, showDarkHeader: true },
    },
    {
        path: '/team/:teamMemberSlug', // Dynamic route for team members by slug
        component: TeamMember,
        meta: { showHeader: false, showFooter: false },
        props: true, // Enable route props
    },
    {
        path: '/case-studies/:CaseStudySlug', // Dynamic route for case studies by slug
        component: CaseStudy,
        meta: { showHeader: true, showFooter: true, showDarkHeader: true },
        props: true, // Enable route props
    },
    {
      path: '/404',
      component: Page404,
      meta: { showHeader: true, showFooter: false, specialFooter: false },
    },
    {
      path: '/:catchAll(.*)',
      component: Page404,
      meta: { showHeader: true, showFooter: false, specialFooter: false },
    }
  ]
})

// Add a global afterEach hook to reset focus after navigation
router.afterEach(() => {
  // Remove focus from any active element
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
  
  // Reset focus to the body element
  document.body.setAttribute('tabindex', '-1');
  document.body.focus();
  document.body.removeAttribute('tabindex');
});

export default router
